<template>
  <vx-card class="org-card">

    <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

      <!-- GENERAL -->
      <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? $t('orgDashboard.userDashboard.settings.account') : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <user-settings-account />
        </div>
      </vs-tab>
      <!-- <vs-tab icon-pack="material-icons" icon="work" :label="!isSmallerScreen ? 'Platform Preferences' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <org-settings-platform-preferences />
        </div>
      </vs-tab> -->
      <!-- <vs-tab icon-pack="material-icons" icon="widgets" :label="!isSmallerScreen ? 'Apps' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <user-settings-apps />
        </div>
      </vs-tab> -->
      <!-- <vs-tab icon-pack="material-icons" icon="settings" :label="!isSmallerScreen ? 'Resume Settings' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <org-settings-resume-settings />
        </div>
      </vs-tab> -->
      <!-- <vs-tab icon-pack="material-icons" icon="help" :label="!isSmallerScreen ? 'Help' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <org-settings-help />
        </div>
      </vs-tab> -->
    </vs-tabs>
  </vx-card>
</template>

<script>
import UserSettingsAccount from './UserSettingsAccount.vue'
import UserSettingsPlatformPreferences from './UserSettingsPlatformPreferences.vue'
import UserSettingsApps from './UserSettingsApps.vue'
import UserSettingsResumeSettings from './UserSettingsResumeSettings.vue'
import UserSettingsHelp from './UserSettingsHelp.vue'

export default {
  components: {
    UserSettingsAccount,
    UserSettingsPlatformPreferences,
    UserSettingsApps,
    UserSettingsResumeSettings,
    UserSettingsHelp
  },
  data () {
    return {

    }
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
